import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredDiamondOrange = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69059 1.22032C3.77804 1.08275 3.92525 1.00011 4.08289 1.00011H11.9171C12.0748 1.00011 12.222 1.08275 12.3094 1.22032L14.9208 5.32901C15.0329 5.50531 15.0254 5.7369 14.9022 5.90484L8.3737 14.807C8.28445 14.9287 8.14638 15 8 15C7.85362 15 7.71555 14.9287 7.6263 14.807L1.09777 5.90484C0.974606 5.7369 0.96713 5.50531 1.07918 5.32901L3.69059 1.22032ZM4.33521 1.98917L2.0512 5.58273L8 13.6944L13.9488 5.58273L11.6648 1.98917H4.33521Z"
      fill="url(#paint0_linear_2950_15952)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.558 1.05232C7.7909 1.17446 7.8853 1.47151 7.76885 1.7158L6.15145 5.10879H9.84855L8.23115 1.7158C8.1147 1.47151 8.2091 1.17446 8.442 1.05232C8.6749 0.930173 8.9581 1.02919 9.07455 1.27348L10.9028 5.10879H14.5285C14.7889 5.10879 15 5.3302 15 5.60332C15 5.87645 14.7889 6.09786 14.5285 6.09786H10.9596L8.4527 14.6438C8.44883 14.6577 8.44438 14.6714 8.43938 14.6849C8.4151 14.7505 8.37858 14.808 8.33347 14.8552C8.28842 14.9025 8.23363 14.9409 8.17103 14.9663C8.11716 14.9884 8.05922 15 8 15C7.94078 15 7.88284 14.9884 7.82897 14.9663C7.76637 14.9409 7.71158 14.9025 7.66653 14.8552C7.62142 14.808 7.58491 14.7505 7.56062 14.6849C7.55562 14.6714 7.55117 14.6577 7.5473 14.6438L5.04037 6.09786H1.47148C1.21109 6.09786 1 5.87645 1 5.60332C1 5.3302 1.21109 5.10879 1.47148 5.10879H5.0972L6.92545 1.27348C7.0419 1.02919 7.3251 0.930173 7.558 1.05232ZM6.02695 6.09786L8 12.8239L9.97305 6.09786H6.02695Z"
      fill="url(#paint1_linear_2950_15952)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2950_15952"
        x1={1}
        y1={1}
        x2={15}
        y2={1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F46606" />
        <stop offset={1} stopColor="#FFEC00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2950_15952"
        x1={1}
        y1={1}
        x2={15}
        y2={1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F46606" />
        <stop offset={1} stopColor="#FFEC00" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredDiamondOrange)
const IconSvgColouredDiamondOrange = createIcon(
  ForwardRef,
  'SvgColouredDiamondOrange',
)
export default IconSvgColouredDiamondOrange
